import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    pendingButton: {
        id: 'notifications.pending.button',
        defaultMessage: 'View in history',
    },
})
